import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const Staff = withLazyFallback(() => import('components/Staff/Staff'));
const Settings = withLazyFallback(() => import('components/practice/Settings/Settings'));
const Account = withLazyFallback(
  () => import('components/practice/Settings/components/Account/Account')
);
const BillingSettings = withLazyFallback(
  () => import('components/practice/Settings/components/Billing/BillingSettings/BillingSettings')
);
const CalendarSettings = withLazyFallback(
  () => import('components/practice/Settings/components/Calendar/Calendar')
);
const Confirmations = withLazyFallback(
  () => import('components/practice/Settings/components/Confirmations/Confirmations')
);
const WorkingHours = withLazyFallback(
  () =>
    import('components/practice/Settings/components/Calendar/components/WorkingHours/WorkingHours')
);
const EPrescribeSettings = withLazyFallback(
  () => import('components/practice/Settings/components/EPrescribe/EPrescribe')
);
const FormBuilder = withLazyFallback(
  () => import('components/practice/Settings/components/Forms/FormBuilder/FormBuilder')
);
const FormPackets = withLazyFallback(
  () => import('components/practice/Settings/components/Forms/FormPackets/FormPackets')
);
const Forms = withLazyFallback(() => import('components/practice/Settings/components/Forms/Forms'));
const KioskSettings = withLazyFallback(
  () => import('components/practice/Settings/components/Kiosks/KioskSettings')
);
const Packages = withLazyFallback(
  () => import('components/practice/Settings/components/Packages/Packages')
);
const Payers = withLazyFallback(
  () => import('components/practice/Settings/components/Payers/Payers')
);
const Products = withLazyFallback(
  () => import('components/practice/Settings/components/Products/Products')
);
const Resources = withLazyFallback(
  () => import('components/practice/Settings/components/Resources/Resources')
);
const Services = withLazyFallback(
  () => import('components/practice/Settings/components/Services/Service')
);
const Tags = withLazyFallback(() => import('components/practice/Settings/components/Tags/Tags'));
const Roles = withLazyFallback(() => import('components/Roles/Roles'));
const Billing = withLazyFallback(
  () => import('components/practice/Settings/components/Billing/Billing')
);

const WriteOffCodes = withLazyFallback(
  () => import('components/practice/Settings/components/Billing/WriteOffCodes/WriteOffCodes')
);

const EditWriteOffCodeModal = withLazyFallback(
  () =>
    import(
      'components/practice/Settings/components/Billing/WriteOffCodes/components/EditWriteOffCodeModal'
    )
);

const PRACTICE_SETTINGS = [
  {
    path: 'settings',
    element: <Settings />,
    children: [
      { path: '', element: <Services /> },
      { path: 'products', element: <Products /> },
      { path: 'packages', element: <Packages /> },
      { path: 'calendar', element: <CalendarSettings /> },
      { path: 'confirmations', element: <Confirmations /> },
      { path: 'working-hours', element: <WorkingHours /> },
      {
        path: 'forms',
        element: <Forms />,
        children: [
          { path: '', element: <FormBuilder /> },
          { path: 'form-packets', element: <FormPackets /> }
        ]
      },
      { path: 'payers', element: <Payers /> },
      { path: 'account', element: <Account /> },
      { path: 'staff', element: <Staff /> },
      { path: 'roles', element: <Roles /> },
      { path: 'eprescribe', element: <EPrescribeSettings /> },
      {
        path: 'billing',
        element: <Billing />,
        children: [
          { path: '', element: <BillingSettings /> },
          {
            path: 'write-off-codes',
            element: <WriteOffCodes />,
            children: [{ path: ':id', element: <EditWriteOffCodeModal /> }]
          }
        ]
      },

      { path: 'kiosk', element: <KioskSettings /> },
      { path: 'resources', element: <Resources /> },
      { path: 'tags', element: <Tags /> },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default PRACTICE_SETTINGS;
